@use "Styles/includes/variables";
@use "Styles/mixins";
@use "Static/icons/icomoon/style.scss";

:host {
    .comment {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 15px;
        align-items: flex-start;
        list-style-type: none;

        &__inner-wrap {
            width: 100%;
            display: flex;
            gap: 15px;
        }

        vm-profile-image {
            width: 48px;
            height: 48px;
            flex-shrink: 0;

            &::part(link) {
                display: block;
                text-decoration: none;
            }

            &::part(figure),
            &::part(image) {
                display: block;
                width: 100%;
                height: auto;
                border-radius: 100%;
            }

            &::part(initials) {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 48px;
                height: 48px;
                border-radius: 100%;
                font-family: variables.$fontPrimary;
                font-size: 21.6px;
                font-style: normal;
                font-weight: 600;
                color: #fff;
                background: mixins.get-color(teal, 900);
            }
        }

        &__content-wrap {
            display: flex;
            flex-direction: column;
            width: 100%;
        }

        &__header {
            display: flex;
            align-items: center;
            column-gap: 5px;
            flex-wrap: wrap;

            a {
                min-height: 24px;
                color: #0092db;
                text-decoration: none;
            }

            small {
                min-height: 24px;
                font-size: 80%;
                line-height: 28px;
                color: #868e96;
            }
        }

        &__main {
            p {
                margin: 0;
                word-wrap: break-word;
            }
        }

        &__attachments-list {
            display: flex;
            gap: 12px;
        }

        &__attachment-item {
            &--image {
                display: block;
                width: 85px;
                border: 1px solid mixins.get-color(neutral, 300);

                a {
                    display: block;
                    font-size: 0;
                    line-height: 0;

                    img {
                        display: block;
                        width: 100%;
                        height: auto;
                    }
                }
            }
        }

        &__footer {
            display: flex;
            gap: 5px;
            flex-wrap: wrap;
            margin: 8px 0 0;
        }

        &__thumbs-up-button {
            a {
                display: flex;
            }
        }

        &__replies-list {
            box-sizing: border-box;
            width: 100%;
            padding: 0 0 0 63px;
            margin: 0;
            list-style-type: none;
        }

        &--reply {
            // a nested replies list won't have any left padding on mobile
            // because the padding will push the content too much
            .comment__replies-list {
                @include mixins.max-screen(variables.$md - 1) {
                    padding: 0;
                }
            }
        }

        vm-button[custom="feature-comment"] {
            margin: 0 0 0 auto;

            &::part(button) {
                border: none;
            }
        }
    }
}
